import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyProfile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3 3C3 2.20435 3.31607 1.44129 3.87868 0.87868C4.44129 0.316071 5.20435 0 6 0C6.79565 0 7.55871 0.316071 8.12132 0.87868C8.68393 1.44129 9 2.20435 9 3C9 3.79565 8.68393 4.55871 8.12132 5.12132C7.55871 5.68393 6.79565 6 6 6C5.20435 6 4.44129 5.68393 3.87868 5.12132C3.31607 4.55871 3 3.79565 3 3Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 7.125C3.27254 7.125 0.75 7.62519 0.75 9.56955C0.75 11.5092 3.25906 12 6 12C8.72662 12 11.25 11.5111 11.25 9.56955C11.25 7.62801 8.74178 7.125 6 7.125Z",
			fill: "#545F7E"
		})
	]
});
const ForwardRef = forwardRef(SvgMyProfile);
export default ForwardRef;
